import { StateCreator } from "zustand";
import Swal from "sweetalert2";
import { DashboardDataType } from "../../../domain/models/data-dashboard-report/dashboard-data";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, DASHBOARD_AUTH_URL, SECURE_AUTH_TOKEN_KEY } from "../../../base";
import { RemoteGetDashboardLink } from "../../../data/usecases/data-dashboard-report/remote-get-dashboard-link";
import Endpoints from "../../../domain/endpoints";
import { CustomerDatabaseStore } from "../../main/CustomerDatabaseStore";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface GetDashboardLinkInterface {
  getSelectedDashboardData: Function;
  formattedLink: string;
  dashboardData: DashboardDataType[];
  fetchDashboardState: FetchState;
}

const initialStates = {
  formattedLink: "",
  dashboardData: [],
  fetchDashboardState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchDashboardDataSlice: StateCreator<
  GetDashboardLinkInterface
> = (set) => ({
  ...initialStates,
  getSelectedDashboardData: async () => {
    set(() => ({ fetchDashboardState: FetchState.LOADING }));

    let payload = {
      user_id: CustomerDatabaseStore.getState().userDetails.id,
      department_name: CustomerDatabaseStore.getState().userDetails.departments[0].customer_service_org_code,
      role: CustomerDatabaseStore.getState().userDetails.role.name,
      name: CustomerDatabaseStore.getState().userDetails.full_name
    };
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteGetDashboardLink = new RemoteGetDashboardLink(
      `${DASHBOARD_AUTH_URL}${Endpoints.DASHBOARD_LINK}`,
      axiosHttpClient
    );

    let result = await remoteGetDashboardLink.get(payload);

    if (result) {
      set(() => ({ fetchDashboardState: FetchState.SUCCESS }));
      set(() => ({ dashboardData: result }));
    } else {
      set(() => ({ fetchDashboardState: FetchState.ERROR }));
      Swal.fire({
        icon: "error",
        title: "No Dashboard Links Found",
        timer: 3000,
      });
    }
  },
  
});
